import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

import { Input } from "../../../../form-inputs/inputs";

class UserGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.data,
        };
    }

    updateField = (key, value) => {
        this.setState({
            [key]: value,
        });

        this.props.updateOnChange({
            ...this.state,
            [key]: value,
        });
    };

    removeItem = () => {
        this.props.removeItem("userGroups", this.state.key);
        document.getElementsByName("newUserGroup")[0].focus();
    };

    render() {
        return (
            <div className="input-group">
                <Input
                    id={`userGroup_${this.state.key}`}
                    name="userGroup"
                    value={this.state.userGroup}
                    label="User Group"
                    updateOnChange={this.updateField}
                />
                <Input
                    id={`userDirections_${this.state.key}`}
                    name="directions"
                    value={this.state.directions}
                    label="Directions"
                    updateOnChange={this.updateField}
                />
                <button className="button -primary -small" onClick={this.removeItem}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                </button>
            </div>
        );
    }
}

export default UserGroup;
